import { useTheme } from "@mui/material/styles";

const HardHatTypeIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="26"
        height="26"
        rx="4"
        fill={theme.palette.otherDivider.main}
      />
      <g clipPath="url(#clip0_29295_5134)">
        <path
          d="M22.0414 17.1381H21.5929V15.498C21.5929 11.969 19.4022 8.7685 16.1259 7.48468V7.08996C16.1259 6.46913 15.6207 5.96399 14.9999 5.96399H10.9776C10.3568 5.96399 9.85167 6.46913 9.85167 7.08996V7.48468C6.57516 8.7685 4.38468 11.9693 4.38468 15.4982V17.1384H3.93596C3.48043 17.1381 3.10986 17.5089 3.10986 17.9644V19.1872C3.10986 19.6428 3.48043 20.0133 3.93596 20.0133H22.0414C22.4969 20.0133 22.8677 19.6428 22.8677 19.1872V17.9644C22.8677 17.5089 22.4971 17.1381 22.0414 17.1381ZM4.82374 15.4982C4.82374 12.2072 6.83136 9.217 9.85167 7.95843V10.9094C9.85167 11.0306 9.95002 11.1289 10.0712 11.1289C10.1924 11.1289 10.2907 11.0306 10.2907 10.9094V7.63616V7.08996C10.2907 6.71127 10.599 6.40305 10.9776 6.40305H12.7692V13.0621C12.7692 13.1833 12.8676 13.2816 12.9888 13.2816C13.1099 13.2816 13.2083 13.1833 13.2083 13.0621V6.40305H14.9999C15.3788 6.40305 15.6868 6.71127 15.6868 7.08996V7.63594V10.9092C15.6868 11.0303 15.7849 11.1287 15.9063 11.1287C16.0277 11.1287 16.1259 11.0303 16.1259 10.9092V7.95821C19.1462 9.21678 21.1538 12.207 21.1538 15.498V17.1381H4.82374V15.4982ZM22.4286 19.1872C22.4286 19.4006 22.255 19.5743 22.0414 19.5743H3.93596C3.72257 19.5743 3.54893 19.4006 3.54893 19.1872V17.9644C3.54893 17.7508 3.72257 17.5772 3.93596 17.5772H4.60399H21.3733H22.0414C22.255 17.5772 22.4286 17.7508 22.4286 17.9644V19.1872Z"
          fill={theme.palette.otherDivider.main}
          stroke={theme.palette.text.secondary}
        />
      </g>
      <defs>
        <clipPath id="clip0_29295_5134">
          <rect
            width="20"
            height="20"
            fill={theme.palette.otherBackgroundLight.main}
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HardHatTypeIcon;
